import { render, staticRenderFns } from "./DownloadTaxCert.vue?vue&type=template&id=7debdb93&scoped=true"
import script from "./DownloadTaxCert.vue?vue&type=script&lang=js"
export * from "./DownloadTaxCert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7debdb93",
  null
  
)

export default component.exports